// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BoxPrice_wrapper__2fTtn","clmaxWidth670":"BoxPrice_clmaxWidth670__3QjEv","clMargin":"BoxPrice_clMargin__1T1LV","buttonMargin":"BoxPrice_buttonMargin__NM5Ns"};